export default __webpack_public_path__ + "static/media/close.5b170fa3.svg";